import { Component, OnInit } from '@angular/core';
import { MatFormField, MatInput } from '@angular/material/input';

@Component({
    selector: 'app-search-box',
    templateUrl: './search-box.component.html',
    styleUrls: ['./search-box.component.scss'],
    imports: [MatFormField, MatInput]
})
export class SearchBoxComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
